import { NgClass } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AsyncSubject, of, takeUntil } from 'rxjs';
import { StateOptionModel } from 'src/lib/services/api/generic/options/state-option.model';
import { OptionsStoreService } from 'src/lib/services/stores/options/options-store.service';
import { UserAddressModel } from 'src/lib/services/utility/utility-models/address.model';
import { InputTrimDirective } from 'src/lib/templates/global/email-trim/input-trim.directive';
import { FormLabelComponent } from 'src/lib/templates/global/form-label/form-label.component';
import { FormControlWrapper } from 'src/lib/types/forms.def';
import { StringEnumOption } from 'src/lib/utilities/api/patterns/dynamic-fields/string-enum-option.model';
import { GroupValidationModule } from '../../layout/group-validation/group-validation.module';

@Component({
	selector: 'ae-address-form',
	templateUrl: './address-form.component.html',
	styleUrls: ['./address-form.component.scss'],
	imports: [
		FormLabelComponent,
		GroupValidationModule,
		InputTrimDirective,
		NgClass,
		NgSelectModule,
		ReactiveFormsModule,
	],
})
export class AddressFormComponent {
	private _unsubscribe$ = new AsyncSubject<null>();

	@Input() excludeZip: boolean = false;
	@Input() formGroup: FormGroup<FormControlWrapper<UserAddressModel>>;
	@Input() stateOptions: StateOptionModel[] | StringEnumOption[] = [];
	@Input() shortenRows: boolean = false;
	@Input() showLabels: boolean = true;
	@Input() reduceSpacing: boolean = false;

	@Input() requiredControls = {
		street: true,
		city: true,
		state: true,
		zip: true,
	};

	@HostBinding('class.custom-form-control') customFormControl = true;

	constructor(private optionsStoreService: OptionsStoreService) {
		this.init();
	}

	private init = () => {
		const obs$ =
			this.stateOptions.length > 0
				? of(this.stateOptions)
				: this.optionsStoreService.states$();

		obs$.pipe(takeUntil(this._unsubscribe$)).subscribe((options) => {
			this.stateOptions = options;
		});
	};
}
